// Copyright (c) Microsoft. All rights reserved.

import { TokenUsage } from '../../../services/providers/progpt/dtos/responses/ProGPTSendMessageResponseDto';
import { Artifact } from './Artifact';
import { ChatCitation } from './ChatCitation';

export enum AuthorRoles {
    User,
    Bot,
    System
}

export enum ChatMessageType {
    Message,
    Document
}


export enum UserFeedback {
    Unknown,
    Requested,
    Positive,
    Negative,
}



export interface ChatMessage {
    chatId: string;
    type: ChatMessageType;
    timestamp: number;
    userName: string;
    content: string;
    artifacts?: Artifact[];
    images?: string[];
    id: string;
    prompt?: string; // user prompt that generated the bot response
    citations?: ChatCitation[];
    agentSources?: string[];
    authorRole: AuthorRoles;
    userFeedback?: UserFeedback; // progpt only i think, its currently not being returned, but we probably should just for consistency
    annotations?: string[];
    modelId?: string; // progpt only
    tokenUsage?: TokenUsage;
}
